import { render, staticRenderFns } from "./BlockVideoAppearance.vue?vue&type=template&id=cc6b7806&scoped=true&"
import script from "./BlockVideoAppearance.vue?vue&type=script&lang=js&"
export * from "./BlockVideoAppearance.vue?vue&type=script&lang=js&"
import style0 from "./BlockVideoAppearance.vue?vue&type=style&index=0&id=cc6b7806&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc6b7806",
  null
  
)

export default component.exports